import { useCallback, useEffect, useMemo } from "react";
import { useQueryParam, StringParam } from "use-query-params";
import { resolveSelectedSite, saveSelectedSite } from "@/utils/selectedSiteStorage";

interface RyteViewReturn {
  site: string | null;
  handleSiteChange: (newSite: string | null | undefined) => void;
}

export const useRyteView = (): RyteViewReturn => {
  const [urlSite, setSite] = useQueryParam("site", StringParam);
  const site = useMemo(() => resolveSelectedSite(urlSite), [urlSite]);

  useEffect(() => {
    const selectedUrlSite = urlSite?.trim();
    if (selectedUrlSite) {
      saveSelectedSite(selectedUrlSite);
      return;
    }

    if (site) {
      setSite(site, "replaceIn");
    }
  }, [urlSite, site, setSite]);

  const handleSiteChange = useCallback(
    (newSite: string | null | undefined) => {
      saveSelectedSite(newSite);
      setSite(newSite);
    },
    [setSite]
  );

  return {
    site,
    handleSiteChange,
  };
};
